import RouteCoverage from './RouteCoverage';

export default RouteCoverage;
